import { components } from "react-select";

export const CountryOption = (props) => (
    <components.Option {...props}>
        <div className="flex items-center gap-2">
            <img
                src={`https://flagcdn.com/w20/${props.data.iso}.png`}
                alt={props.data.name}
                className="w-5 h-4 object-cover"
                onError={(e) => (e.target.style.display = "none")}
            />
            <span>{props.data.label}</span>
        </div>
    </components.Option>
);

export const CountrySingleValue = (props) => (
    <components.SingleValue {...props}>
        <div className="flex items-center gap-2">
            <img
                src={`https://flagcdn.com/w20/${props.data.iso}.png`}
                alt={props.data.name}
                className="w-5 h-4 object-cover"
                onError={(e) => (e.target.style.display = "none")}
            />
            <span>{props.data.label}</span>
        </div>
    </components.SingleValue>
);
